import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '~~/tailwind.config'

const useColors = () => {
  const colors = resolveConfig(tailwindConfig).theme.colors
  return { colors }
}

export default useColors
